import { SubmissionState } from 'preflight-core';

import { Journal } from '../resources/journal';
import { Voucher } from '../vouchers/get-voucher';
import { MacrosBanner } from './macros-banner';
import { SampleDocumentBanner } from './sample-document-banner';
import { ServiceUnavailableBanner } from './service-unavaliable-banner';
import { TestModeBanner } from './test-mode-banner';

export const TopBannersHome = ({
  submissionState,
  hasMacros,
  showServiceUnavaliable,
  journal,
}: {
  submissionState: SubmissionState | null;
  hasMacros: boolean;
  showServiceUnavaliable: boolean;
  journal: Journal;
  voucher: Voucher | null;
}) => {
  const macrosBanner = hasMacros ? <MacrosBanner /> : undefined;
  const testModeBanner = journal.testMode ? <TestModeBanner /> : undefined;
  // TODO: Setup a wat to turn this banner on/off from an
  const serviceUnavailableBanner = showServiceUnavaliable ? (
    <ServiceUnavailableBanner />
  ) : undefined;
  const sampleResultBanner = submissionState ? (
    submissionState.name === 'SAMPLE' ? (
      <SampleDocumentBanner
        journalId={journal.slug}
        publisherId={journal.publisher.slug}
      />
    ) : undefined
  ) : undefined;
  const voucherBanner = undefined;

  return (
    <>
      {testModeBanner}
      {sampleResultBanner}
      {macrosBanner}
      {voucherBanner}
      {serviceUnavailableBanner}
    </>
  );
};
